import React from "react";
import { Line } from "react-chartjs-2";
import "chart.js"; // No need to manually register components in v2

import * as moment from "moment";

const LineChart = ({ data }) => {

  let value = { labels: [], datasets: [{ data: [], backgroundColor: [] }] };
  if (data && data.length > 0) {
    value.labels = data.map((element) => moment(element.month).format("MMM YYYY"));
    value.datasets = [
      {
        data: data.map((element) => element.user_count),
        label: "User",
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ];
  }

  const options = {
    title: {
      display: true,
      text: "New Users",
      fontSize: 18, // Title font size
      fontColor: "#333", // Title color
    },
    responsive: true,
  };
  return <Line options={options} data={value} />;
};

export default LineChart;
